import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { BreakpointContext, useBreakpoints } from 'react-use-breakpoints';
import { Text } from '../Text';
import { EmployerCard } from '../EmployerCard';
import { RevealingBox } from '../RevealingBox';

const StyledTestimonialThumbnail = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  border-radius: ${rem(`16px`)};
  margin-right: 0;
  transform: scale(1);
  transition: box-shadow 0.8s, transform 0.6s;
  pointer-event: none;
  flex: 1 0 auto;
  width: 100%;
  height: 100%;
  &:last-child {
    margin-bottom: 0;
    ${({ theme }) => theme.breakpoints.phablet`
      margin-right: 0;
      margin-bottom: 0;
    `}
  }
  .testimonial-thumbnail__main {
    display: flex;
    flex-wrap: wrap;
    flex: 1 0;
    color: ${({ theme }) => theme.colors.white_1};
  }
  .testimonial-thumbnail__wrapper {
    display: flex;
    pointer-event: all;
    flex: 1 0 100%;
    flex-wrap: wrap;
    padding: 1px;
    margin: 1px;
    border-radius: ${rem(`16px`)};
    position: relative;
    box-sizing: border-box;
    background-clip: padding-box;
    border: solid 1px transparent;
    transition: all 0.5s ease;
    background: ${({ theme }) => `linear-gradient(
      265deg,
      ${theme.colors.blue_1_65},
      ${theme.colors.blue_1},
      ${theme.colors.blue_1_90}
    )`};
    ::before {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      border-radius: inherit;
      margin: -2px;
      z-index: -1;
      background: ${({ theme }) => `linear-gradient(
          -150deg,
          ${theme.colors.blue_1_30},
          ${theme.colors.blue_1_65},
          ${theme.colors.pink_2}
        )`};
    }
  }

  .testimonial-thumbnail__container {
    padding: ${rem(`16px`)};
    border-radius: ${rem(`16px`)};
    margin: -2px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    flex: 1 0 auto;
    justify-content: flex-start;
    align-items: flex-start;
    overflow: hidden;
    position: relative;
    width: 100%;
    ${({ theme }) => theme.breakpoints.phablet`
      padding: ${rem(`24px`)};
    `}
  }
  .employer-card {
    margin-bottom: ${rem(`16px`)};
    ${({ theme }) => theme.breakpoints.phablet`
      margin-bottom: ${rem(`24px`)};
    `}
  }
  .revealing-box,
  .recommendation {
    text-align: start;
  }
`;

export interface ITestimonialThumbnail {
  className?: string;
  image: any;
  alt: string;
  name: string;
  role: string;
  clientName: string;
  clientSlug: string;
  linkedInUrl: string;
  recommendation: any;
  slide: any;
  displayId: any;
  idx: number;
}

export const TestimonialThumbnail = ({
  className,
  image,
  alt,
  name,
  role,
  clientName,
  clientSlug,
  linkedInUrl,
  recommendation,
  slide,
  displayId,
  idx,
}: ITestimonialThumbnail) => {
  const breakpoints = React.useContext(BreakpointContext);
  const { breakpoint } = useBreakpoints(breakpoints);
  const isUnderPhablet = [`watch`, `phone`].some((item) => item === breakpoint);
  return (
    <StyledTestimonialThumbnail className={className}>
      <div className="testimonial-thumbnail__main">
        <div className="testimonial-thumbnail__wrapper">
          <div className="testimonial-thumbnail__container">
            <EmployerCard
              name={name}
              imageUrl={image}
              alt={alt}
              role={role}
              client={clientName}
              clientSlug={clientSlug}
              linkedInUrl={linkedInUrl}
              className="employer-card"
            />

            {isUnderPhablet ? (
              <RevealingBox
                height={100}
                key={displayId}
                value={slide === idx ? null : false}
                className="revealing-box"
              >
                <Text
                  noRhythem
                  type="body3"
                  tag="span"
                  className="recommendation"
                >
                  {recommendation.recommendation}
                </Text>
              </RevealingBox>
            ) : (
              <Text
                noRhythem
                type="body3"
                tag="span"
                className="recommendation"
              >
                {recommendation.recommendation}
              </Text>
            )}
          </div>
        </div>
      </div>
    </StyledTestimonialThumbnail>
  );
};
